import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-empty-state-actions, [glxyEmptyStateActions]',
  standalone: false,
})
export class EmptyStateActionsDirective {
  @HostBinding('class') class = 'glxy-empty-state-actions';
}
